import React from 'react'
import SupermarketProductContainer from '../../../../Components/ProductRegisterPart/SupermarketProductContainer/SupermarketProductContainer'
import Layout from '../../Layout'

const SupermarketProduct = () => {
  return (
    <Layout>
      <SupermarketProductContainer/>
    </Layout>
  )
}

export default SupermarketProduct